import { Button, ButtonGroup } from "@mui/material"

import React from "react"

import { CreateAgentStage, CreateAgentAnimation } from "./CreateAgentAnimation"

export function AnimTestPage() {
  const [stage, setStage] = React.useState<CreateAgentStage>("spawning")

  // React.useEffect(() => {
  //   setTimeout(() => {
  //     setStage("spawning")
  //   }, 2000)
  //   setTimeout(() => {
  //     setStage("top-up")
  //   }, 4000)
  //   setTimeout(() => {
  //     setStage("connecting")
  //   }, 6000)
  //   setTimeout(() => {
  //     setStage("receiving")
  //   }, 8000)
  //   setTimeout(() => {
  //     setStage("finalizing")
  //   }, 10000)
  // }, [])

  return (
    <>
      <CreateAgentAnimation stage={stage} />
      <ButtonGroup color="secondary">
        <Button
          onClick={() => {
            setStage("spawning")
          }}
        >
          1
        </Button>
        <Button
          onClick={() => {
            setStage("top-up")
          }}
        >
          2
        </Button>
        <Button
          onClick={() => {
            setStage("connecting")
          }}
        >
          3
        </Button>
        <Button
          onClick={() => {
            setStage("receiving")
          }}
        >
          4
        </Button>
        <Button
          onClick={() => {
            setStage("finalizing")
          }}
        >
          5
        </Button>
      </ButtonGroup>
    </>
  )
}
